import "./onboarding-plan-info.scss"
import {PlanStore} from "../../../../../pages/subscription-plans/stores/subscription-plans-store";
import { observer } from "mobx-react";
import OnboardingCoveragePlanHeader from "./onboarding-coverage-plan-header";
import OnboardingPlanHeader from "./onboarding-plan-header";
import OnboardingPlanDescription from "../onboarding-plan-description/onboarding-plan-description";

export interface IPlanInfo {
    plan: PlanStore;
    isExpanded: boolean;
    onToggle: () => void;
}

const OnboardingPlanInfo: React.FC<IPlanInfo> = observer(({plan, isExpanded, onToggle}: IPlanInfo) => {
    if (!plan) {
        return null;
    }

    return (
        <div className="onboarding-plan-info-wrapper">
            <div className="onboarding-plan-info-header">
                {plan.isDefaultCoveragePlan 
                    ? <OnboardingCoveragePlanHeader plan={plan}/>
                    : <OnboardingPlanHeader plan={plan} />}
            </div>
            <div className="onboarding-plan-info-description">
                <OnboardingPlanDescription plan={plan} isExpanded={isExpanded} onToggle={onToggle} />
            </div>
        </div>
    )
});

export default OnboardingPlanInfo;